import styled from "styled-components";
import EmailIcon from "./img/email_black.png"
import PopUpImg from "./img/femaleRK.png"
import { useForm } from "react-hook-form";
import EmailConfirmFormulary, { GenerateValidationCodeFunction } from "../../../EmailConfirmFormulary/EmailConfirmFormulary";
import { useContext } from "react";
import { PageContext } from "../../../Context/PageContext";
import ChangeLionsUserPassword from "./meucadastro/ChangeLionsUserPassword";
import RecoverAccountPassword from "./meucadastro/RecoverAccountPassword";

function RecoverAccount(){

    const { register, getValues } = useForm();
    const { setPopMenuContent} = useContext(PageContext)


    
    function RecoverAccountFunction() {
        setPopMenuContent(<RecoverAccountPassword email={getValues('userEmail')}/>);
    }

    function SubmitActionCheck(e) {

        if(getValues('userEmail') == '' || getValues('userEmail').includes("@") == false || getValues('userEmail').includes(".") == false || getValues('userEmail').length < 5) {
            
            e.target.nextSibling.style.opacity = .5;
            e.target.nextSibling.style.pointerEvents = "none"
            return;
        } else {
            e.target.nextSibling.style.opacity = 1;
            e.target.nextSibling.style.pointerEvents = "auto"
            return;
        }
    }

    return(
        <MasterContainer>
        <ColumnMaster>

            <Fieldset id="recuperarConta" >
            <legend><h1>Recuperação de Conta</h1></legend>

            <ColumnItemContainer>
                <ColumItemHeader>
                    <ColumItemHeaderIcon iconImg={EmailIcon}/>
                    <ColumItemHeaderName>PRECISA RECUPERAR SUA CONTA?</ColumItemHeaderName>
                </ColumItemHeader>
            </ColumnItemContainer>

            <Span>
            Para recuperar sua conta, preencha o campo abaixo com o email cadastrado. Você receberá as instruções para poder prosseguir com a operação.
            </Span>

            <Input  
            {...register('userEmail', {
                onChange: (e) => {SubmitActionCheck(e)}
            })}

            type="email" size="30" required placeholder=" Seu email cadastrado"/>

            <ConfirmInput type="submit" value="Recuperar Acesso"
            onClick={(e) => {
                GenerateValidationCodeFunction("Cliente LionsRagnarok", getValues('userEmail'), "codeToEmail");
                setPopMenuContent(
                    <EmailConfirmFormulary
                        ActionFunction={RecoverAccountFunction}
                        userMail={getValues('userEmail')}>
                    </EmailConfirmFormulary>
                        )}}/>

	        </Fieldset>
        </ColumnMaster>

         <BgPopUp bgp={PopUpImg}/>
        </MasterContainer>

    );
}

export default RecoverAccount;

const ColumnMaster = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 0px;
    background-color: white;
    border-radius: 10px;
    //border: solid 2px black;
    
    @media (max-width: 1000px) {
    width: 90vw;
    }
    
`

const Fieldset = styled.fieldset`
    margin: 0px 0;
    width: 500px;
	height: 350px;
    padding: 0px 30px;
    border: solid 1px rgba(0,0,0,.0);
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    //box-shadow: 10px 10px 10px 0 black;

    @media (max-width: 1000px) {
    width: 80vw;
    }
`

const Span = styled.div`
    text-align: justify;
    letter-spacing: .5px;
    width: 500px;
    margin: 20px 0;

    @media (max-width: 1000px) {
    width: 100%;
    }
`

const ColumnItemContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 500px;
    //border: solid 2px black;
    margin: 10px 0;

    @media (max-width: 1000px) {
    width: 100%;
    }
`

const ColumItemHeader = styled.div`
    display: flex;
    align-items: center;
    width: 330px;
    //border: solid 2px black;

    @media (max-width: 1000px) {
    width: 100%;
    }
`

const ColumItemHeaderIcon = styled.div`
    background-image: url(${props => props.iconImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 25px;
    height: 25px;
    margin-right: 20px;
`

const ColumItemHeaderName = styled.span`
    font-weight: bold;
`

const Input = styled.input`
    height: 30px;
    width: 500px;
    margin: 10px 0;
    border-radius: 2px;
    border: solid 1px rgba(0,0,0,.5);
    font-size: 16px;

    @media (max-width: 1000px) {
    width: 100%;
    }
`

const ConfirmInput = styled.input`
    padding: 10px 30px;
    width: 200px;
    margin: 30px 0;
    border-radius: 5px;
    border: none;
    font-size: 16px;
    background-color: rgb(28, 105, 160);
    color: white;
    transition: .3s ease-in-out;
    opacity: .5;
    pointer-events: none;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }
`

const BgPopUp = styled.div`
    background-image: url(${props => props.bgp});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 405px;
    height: 530px;
    //border: solid;

`

const MasterContainer = styled.div`
    display: flex;
    border: solid 1px;
    align-items: center;
    background-color: white;
    border-radius: 10px;
    box-shadow: 10px 10px 10px 0 black;
    height: 100%;
`